import { defaultSkyScrapper, IAdUnit } from "../unit";

export enum HomepageSkyscraperEnum {
  HomepageSkyscraperL1="Homepage Skyscraper L1",
  HomepageSkyscraperR1="Homepage Skyscraper R1",
}

type HomepageSkyscraperEnumT = typeof HomepageSkyscraperEnum;

export const homepageSkyscraperUnits: {[name in HomepageSkyscraperEnumT[keyof HomepageSkyscraperEnumT]]: IAdUnit} = {
  [HomepageSkyscraperEnum.HomepageSkyscraperL1]: {
    ...defaultSkyScrapper,
    sid: "1232677",
  },
  [HomepageSkyscraperEnum.HomepageSkyscraperR1]: {
    ...defaultSkyScrapper,
    sid: "1232678",
  },
};
